var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpIs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "KPI_Dashboard",
    "data-name": "KPI Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 243.21,
    viewBox: "0 0 250 243.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25212",
    "data-name": "Rectangle 25212",
    width: 250,
    height: 243.21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#695d89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54356a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.094,
    x2: 0,
    y2: 0.899,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62669b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69616",
    "data-name": "Path 69616",
    d: "M1146.58,701.748a12.629,12.629,0,0,0,6.1-1.7c.2-.11.4-.22.6-.333.1-.059.2-.121.3-.18s.2-.121.3-.183c.2-.128.4-.256.6-.388a24.837,24.837,0,0,0,2.593-1.989l-3.494-10.258Z",
    transform: "translate(-1146.58 -686.722)",
    fill: "#f4c750"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25200",
    "data-name": "Rectangle 25200",
    width: 22.51,
    height: 25.42,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25201",
    "data-name": "Rectangle 25201",
    width: 33.214,
    height: 31.649,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25202",
    "data-name": "Rectangle 25202",
    width: 37.37,
    height: 19.844,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.78,
    y1: -0.071,
    x2: 0.574,
    y2: 1.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84ae7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496faf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69645",
    "data-name": "Path 69645",
    d: "M1675.323,201.649a9.332,9.332,0,0,1,1.085,4.652c0,6.713-4.983,15.034-11.449,19.548l.231,4.692c8.25-1.342,19.7-13.135,19.7-22.428,0-3.177-4.5-10.2-5.935-11.988Z",
    transform: "translate(-1664.959 -196.124)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69646",
    "data-name": "Path 69646",
    d: "M1721.35,226.681a9.335,9.335,0,0,1,1.085,4.652c0,6.713-4.982,15.034-11.449,19.548l.231,4.692c9.017-6.07,16.024-17.634,16.024-26.926a11.732,11.732,0,0,0-2.263-7.49Z",
    transform: "translate(-1710.986 -221.156)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25206",
    "data-name": "Rectangle 25206",
    width: 24.687,
    height: 27.871,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67262",
    "data-name": "Group 67262",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67239",
    "data-name": "Group 67239",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67238",
    "data-name": "Group 67238",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69407",
    "data-name": "Path 69407",
    d: "M615.181,1538.516v3.983a6.93,6.93,0,0,1-4.193-.96l-53.8-32.454c-1.635-.99-2.358-6.389-1.136-7.672.172.18.9,3.539,1.136,3.682l53.8,32.462a6.875,6.875,0,0,0,4.193.96",
    transform: "translate(-495.334 -1338.942)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69408",
    "data-name": "Path 69408",
    d: "M710.339,1107.811l-82.917,48.2a6.833,6.833,0,0,1-2.835.9v-3.983a6.873,6.873,0,0,1-4.193-.96l-53.8-32.462a3.029,3.029,0,0,1-.608-.488,2.932,2.932,0,0,1,.653-.51l46.57-27.069,37.15-21.594a5.956,5.956,0,0,1,6.083.052l53.943,32.537a2.937,2.937,0,0,1,.787.69,3.117,3.117,0,0,1-.833,4.688",
    transform: "translate(-504.74 -953.353)",
    fill: "#75525b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69409",
    "data-name": "Path 69409",
    d: "M572.267,281.014v73.177a5.446,5.446,0,0,1-2.715,4.711l-87.485,50.7c-.292.165.278,2.018-.021,2.071-1.763.375-4.434-2.693-4.434-4.636V334.544a7.781,7.781,0,0,1,.78-3.42l3.675,2.257a7.846,7.846,0,0,1,3.038-3.165l85.6-49.615a3.287,3.287,0,0,1,1.448-.45,3.241,3.241,0,0,1,.112.863",
    transform: "translate(-425.929 -249.835)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69410",
    "data-name": "Path 69410",
    d: "M604.976,283.439v73.185a5.446,5.446,0,0,1-2.715,4.71l-87.485,50.7a2.964,2.964,0,0,1-4.425-2.19,3.03,3.03,0,0,1-.023-.375V343.539c0-1.305.323-9.134.915-10.252a7.846,7.846,0,0,1,3.038-3.165l85.6-49.615a3.383,3.383,0,0,1,2.978-.21l.023.008a3.366,3.366,0,0,1,1.335,1l.008.008a3.328,3.328,0,0,1,.75,2.13",
    transform: "translate(-455.104 -249.741)",
    fill: "#461d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69411",
    "data-name": "Path 69411",
    d: "M628.051,309.72V382.9a2.271,2.271,0,0,1-1.124,1.955l-87.145,50.495,0-58.753v-6.78c0-.77.188-8.088.543-8.761a4.691,4.691,0,0,1,1.819-1.9l85.6-49.616h.035l.079-.031.118.048.057.066a.187.187,0,0,1,.013.092",
    transform: "translate(-481.37 -276.022)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69412",
    "data-name": "Path 69412",
    d: "M580.114,259.464a3.382,3.382,0,0,0-2.977.21l-85.6,49.615a7.846,7.846,0,0,0-3.038,3.165l-3.675-2.258a7.875,7.875,0,0,1,3.173-3.435l5.258-3.045,80.352-46.57a3.359,3.359,0,0,1,3.923.382l.023.015Z",
    transform: "translate(-432.358 -228.909)",
    fill: "#9a797d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69413",
    "data-name": "Path 69413",
    d: "M628.086,309.72v12.2l-88.265,51.155v-3.258c0-.77.188-8.088.543-8.761a4.689,4.689,0,0,1,1.819-1.9l85.6-49.616h.035l.079-.031.118.048.057.066a.188.188,0,0,1,.013.092",
    transform: "translate(-481.406 -276.022)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69414",
    "data-name": "Path 69414",
    d: "M704.666,1070.294a3.076,3.076,0,0,1-.833.7l-82.917,48.19a6.96,6.96,0,0,1-2.835.908,6.872,6.872,0,0,1-4.193-.96l-53.8-32.462a3.039,3.039,0,0,1-.608-.487,2.9,2.9,0,0,1,.653-4.493l39.715-23.086,44-25.576a5.973,5.973,0,0,1,6.083.045l53.943,32.544a3.123,3.123,0,0,1,.787,4.673",
    transform: "translate(-498.234 -920.523)",
    fill: "#f0dbd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69415",
    "data-name": "Path 69415",
    d: "M805.33,1113.644l-68.183,39.767a3.611,3.611,0,0,1-3.68-.03l-28.194-17.009a1.518,1.518,0,0,1,.021-2.613l68.6-40.011a3.129,3.129,0,0,1,3.189.026l28.267,17.053a1.637,1.637,0,0,1-.023,2.817",
    transform: "translate(-628.299 -975.014)",
    fill: "#755259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69416",
    "data-name": "Path 69416",
    d: "M821.568,1425.793l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228",
    transform: "translate(-728.109 -1270.229)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69417",
    "data-name": "Path 69417",
    d: "M855.723,1405.849a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.484,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-761.022 -1250.979)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69418",
    "data-name": "Path 69418",
    d: "M892.63,1384.264a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.255.255,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.211Z",
    transform: "translate(-793.935 -1231.729)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69419",
    "data-name": "Path 69419",
    d: "M929.537,1362.679a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-826.849 -1212.481)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69420",
    "data-name": "Path 69420",
    d: "M966.444,1341.093a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-859.761 -1193.231)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69421",
    "data-name": "Path 69421",
    d: "M1003.35,1319.509a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.212Z",
    transform: "translate(-892.674 -1173.982)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69422",
    "data-name": "Path 69422",
    d: "M1040.257,1297.923a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-925.587 -1154.732)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69423",
    "data-name": "Path 69423",
    d: "M1077.164,1276.337a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-958.501 -1135.482)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69424",
    "data-name": "Path 69424",
    d: "M1114.071,1254.752a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-991.413 -1116.232)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69425",
    "data-name": "Path 69425",
    d: "M1150.978,1233.167a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-1024.327 -1096.983)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69426",
    "data-name": "Path 69426",
    d: "M1187.885,1211.581a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-1057.24 -1077.733)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69427",
    "data-name": "Path 69427",
    d: "M1224.792,1189.995a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.255.255,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.211Z",
    transform: "translate(-1090.153 -1058.483)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69428",
    "data-name": "Path 69428",
    d: "M1261.7,1168.411a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-1123.067 -1039.234)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69429",
    "data-name": "Path 69429",
    d: "M1298.606,1146.825a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.437a.123.123,0,0,0,0,.212Z",
    transform: "translate(-1155.98 -1019.985)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69430",
    "data-name": "Path 69430",
    d: "M863.927,1451.308l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228",
    transform: "translate(-765.884 -1292.983)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69431",
    "data-name": "Path 69431",
    d: "M898.271,1428.323l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0",
    transform: "translate(-798.797 -1273.732)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69432",
    "data-name": "Path 69432",
    d: "M935.288,1409.784l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.258.258,0,0,0-.26,0l-2.484,1.438a.122.122,0,0,0,0,.211l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-831.71 -1254.484)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69433",
    "data-name": "Path 69433",
    d: "M972.084,1385.154l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.255.255,0,0,0-.26,0",
    transform: "translate(-864.623 -1235.234)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69434",
    "data-name": "Path 69434",
    d: "M1008.991,1363.569l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0",
    transform: "translate(-897.536 -1215.984)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69435",
    "data-name": "Path 69435",
    d: "M1045.9,1341.985l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.258.258,0,0,0-.26,0",
    transform: "translate(-930.45 -1196.736)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69436",
    "data-name": "Path 69436",
    d: "M1082.805,1320.4l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0",
    transform: "translate(-963.363 -1177.486)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69437",
    "data-name": "Path 69437",
    d: "M1119.713,1298.813l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0",
    transform: "translate(-996.276 -1158.236)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69438",
    "data-name": "Path 69438",
    d: "M1156.619,1277.228l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.257.257,0,0,0-.26,0",
    transform: "translate(-1029.189 -1138.987)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69439",
    "data-name": "Path 69439",
    d: "M1193.526,1255.642l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.256.256,0,0,0-.26,0",
    transform: "translate(-1062.102 -1119.737)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69440",
    "data-name": "Path 69440",
    d: "M1230.432,1234.057l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0",
    transform: "translate(-1095.015 -1100.487)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69441",
    "data-name": "Path 69441",
    d: "M1267.34,1212.472l-2.485,1.437a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.229l-2.3-1.394a.256.256,0,0,0-.26,0",
    transform: "translate(-1127.929 -1081.238)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69442",
    "data-name": "Path 69442",
    d: "M1306.809,1192.284l-2.3-1.393a.256.256,0,0,0-.26,0l-2.484,1.437a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.133.133,0,0,0,0-.229",
    transform: "translate(-1160.841 -1061.989)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69443",
    "data-name": "Path 69443",
    d: "M1338.667,1170.952l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.484,1.438a.123.123,0,0,0,0,.212",
    transform: "translate(-1193.755 -1042.74)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69444",
    "data-name": "Path 69444",
    d: "M910.278,1455.467a.132.132,0,0,0,0-.229l-2.3-1.393a.256.256,0,0,0-.26,0l-.939.543c-.005,0-.011,0-.016,0l-.972.568-.557.322s0,0,0,0l-3.993,2.332a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l4.5-2.63Z",
    transform: "translate(-803.659 -1296.489)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69445",
    "data-name": "Path 69445",
    d: "M977.347,1435.294a.3.3,0,0,0,.3,0l2.45-1.418a.133.133,0,0,0,0-.229l-2.3-1.393a.255.255,0,0,0-.26,0l-2.484,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-869.484 -1277.238)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69446",
    "data-name": "Path 69446",
    d: "M1014.443,1410.67l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.294.294,0,0,0,.3,0l2.45-1.417a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0",
    transform: "translate(-902.398 -1257.989)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69447",
    "data-name": "Path 69447",
    d: "M1051.35,1389.085l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.294.294,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.258.258,0,0,0-.26,0",
    transform: "translate(-935.311 -1238.74)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69448",
    "data-name": "Path 69448",
    d: "M1088.257,1367.5l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0",
    transform: "translate(-968.224 -1219.49)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69449",
    "data-name": "Path 69449",
    d: "M1125.164,1345.914l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.256.256,0,0,0-.26,0",
    transform: "translate(-1001.138 -1200.241)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69450",
    "data-name": "Path 69450",
    d: "M1162.071,1324.328l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0",
    transform: "translate(-1034.05 -1180.99)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69451",
    "data-name": "Path 69451",
    d: "M1198.978,1302.743l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.255.255,0,0,0-.26,0",
    transform: "translate(-1066.964 -1161.741)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69452",
    "data-name": "Path 69452",
    d: "M1235.885,1281.157l-2.484,1.438a.122.122,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.255.255,0,0,0-.26,0",
    transform: "translate(-1099.877 -1142.491)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69453",
    "data-name": "Path 69453",
    d: "M1272.9,1262.616l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1132.79 -1123.242)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69454",
    "data-name": "Path 69454",
    d: "M1309.957,1237.991a.256.256,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-1165.702 -1103.993)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69455",
    "data-name": "Path 69455",
    d: "M1346.6,1197.152l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l.858-.5c.012,0,.026,0,.038-.01l5.549-3.248a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-3.989,2.334Z",
    transform: "translate(-1198.616 -1065.493)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69456",
    "data-name": "Path 69456",
    d: "M948.644,1502.338l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.211l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228",
    transform: "translate(-841.434 -1338.491)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69457",
    "data-name": "Path 69457",
    d: "M980.5,1481.006l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.211",
    transform: "translate(-874.346 -1319.243)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69458",
    "data-name": "Path 69458",
    d: "M1017.408,1459.421l2.3,1.389a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.437a.123.123,0,0,0,0,.212",
    transform: "translate(-907.26 -1299.993)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69459",
    "data-name": "Path 69459",
    d: "M1056.912,1439.229l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-940.173 -1280.744)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69460",
    "data-name": "Path 69460",
    d: "M1093.819,1417.644l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.484,1.438a.122.122,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-973.086 -1261.494)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69461",
    "data-name": "Path 69461",
    d: "M1130.726,1396.059l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.484,1.438a.122.122,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1005.999 -1242.244)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69462",
    "data-name": "Path 69462",
    d: "M1167.633,1374.473l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.211l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1038.912 -1222.994)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69463",
    "data-name": "Path 69463",
    d: "M1204.539,1352.887l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.255.255,0,0,0-.259,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1071.825 -1203.744)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69464",
    "data-name": "Path 69464",
    d: "M1241.447,1331.3l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.255.255,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1104.738 -1184.496)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69465",
    "data-name": "Path 69465",
    d: "M1278.354,1309.717l2.451-1.418a.133.133,0,0,0,0-.229l-2.3-1.394a.255.255,0,0,0-.26,0l-2.485,1.437a.122.122,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1137.652 -1165.246)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69466",
    "data-name": "Path 69466",
    d: "M1315.261,1288.131l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.254.254,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1170.565 -1145.996)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69467",
    "data-name": "Path 69467",
    d: "M1352.057,1263.5l-2.485,1.438a.122.122,0,0,0,0,.211l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.259,0",
    transform: "translate(-1203.479 -1126.747)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69468",
    "data-name": "Path 69468",
    d: "M1389.075,1244.962l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1236.392 -1107.498)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69469",
    "data-name": "Path 69469",
    d: "M1423.384,1221.981l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.211",
    transform: "translate(-1269.305 -1088.248)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69470",
    "data-name": "Path 69470",
    d: "M991,1527.854l-2.3-1.393a.257.257,0,0,0-.26,0l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.133.133,0,0,0,0-.229",
    transform: "translate(-879.208 -1361.246)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69471",
    "data-name": "Path 69471",
    d: "M1025.157,1507.912a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212Z",
    transform: "translate(-912.121 -1341.997)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69472",
    "data-name": "Path 69472",
    d: "M1062.365,1486.33l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.211l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-945.035 -1322.748)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69473",
    "data-name": "Path 69473",
    d: "M1099.271,1464.744l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-977.948 -1303.498)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69474",
    "data-name": "Path 69474",
    d: "M1136.177,1443.159l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.294.294,0,0,0,.3,0",
    transform: "translate(-1010.861 -1284.248)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69475",
    "data-name": "Path 69475",
    d: "M1173.084,1421.574l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1043.774 -1264.999)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69476",
    "data-name": "Path 69476",
    d: "M1209.991,1399.988l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1076.687 -1245.748)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69477",
    "data-name": "Path 69477",
    d: "M1246.9,1378.4l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.393a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1109.6 -1226.499)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69478",
    "data-name": "Path 69478",
    d: "M1283.8,1356.818l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.258.258,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1142.513 -1207.25)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69479",
    "data-name": "Path 69479",
    d: "M1320.712,1335.232l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.255.255,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1175.426 -1188)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69480",
    "data-name": "Path 69480",
    d: "M1357.618,1313.646l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.255.255,0,0,0-.26,0l-2.484,1.437a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1208.339 -1168.75)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69481",
    "data-name": "Path 69481",
    d: "M1394.525,1292.061l2.45-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1241.252 -1149.501)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69482",
    "data-name": "Path 69482",
    d: "M1431.432,1270.477l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0",
    transform: "translate(-1274.165 -1130.252)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69483",
    "data-name": "Path 69483",
    d: "M1465.742,1247.5l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212",
    transform: "translate(-1307.079 -1111.002)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69484",
    "data-name": "Path 69484",
    d: "M1031.058,1551.974a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.389a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-916.983 -1383.999)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69485",
    "data-name": "Path 69485",
    d: "M1067.964,1530.391a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-949.896 -1364.751)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69486",
    "data-name": "Path 69486",
    d: "M1104.871,1508.805a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-982.809 -1345.502)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69487",
    "data-name": "Path 69487",
    d: "M1141.779,1487.219a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-1015.722 -1326.252)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69488",
    "data-name": "Path 69488",
    d: "M1194.66,1379.293a.255.255,0,0,0-.26,0l-1.213.7a.247.247,0,0,0-.154.027l-17.093,10.052a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l3.954-2.326a.268.268,0,0,0,.04-.01l2.45-1.418c.021-.012.021-.036.032-.055l1.432-.842a.28.28,0,0,0,.079-.02l2.451-1.418c.029-.016.034-.047.043-.074l1.381-.812a.294.294,0,0,0,.118-.03l2.451-1.418a.125.125,0,0,0,.056-.095l1.334-.785a.3.3,0,0,0,.153-.038l2.45-1.418a.133.133,0,0,0,0-.229Z",
    transform: "translate(-1048.635 -1230.004)",
    fill: "#390614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69489",
    "data-name": "Path 69489",
    d: "M1363.219,1357.708a.257.257,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-1213.201 -1210.755)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69490",
    "data-name": "Path 69490",
    d: "M1400.127,1336.122a.256.256,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-1246.115 -1191.505)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69491",
    "data-name": "Path 69491",
    d: "M1437.033,1314.538a.257.257,0,0,0-.26,0l-2.485,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-1279.027 -1172.256)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69492",
    "data-name": "Path 69492",
    d: "M1473.94,1292.951a.257.257,0,0,0-.26,0l-2.484,1.438a.123.123,0,0,0,0,.212l2.3,1.39a.3.3,0,0,0,.3,0l2.45-1.418a.132.132,0,0,0,0-.228Z",
    transform: "translate(-1311.94 -1153.006)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69493",
    "data-name": "Path 69493",
    d: "M1513.15,1272.76l-2.3-1.394a.256.256,0,0,0-.26,0l-2.485,1.438a.122.122,0,0,0,0,.211l2.3,1.39a.3.3,0,0,0,.3,0l2.451-1.418a.132.132,0,0,0,0-.228",
    transform: "translate(-1344.854 -1133.756)",
    fill: "#3d415b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69494",
    "data-name": "Path 69494",
    d: "M821.566,1421.6l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-728.109 -1266.284)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69495",
    "data-name": "Path 69495",
    d: "M858.474,1400.011l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-761.022 -1247.034)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69496",
    "data-name": "Path 69496",
    d: "M895.38,1378.426l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-793.935 -1227.785)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69497",
    "data-name": "Path 69497",
    d: "M932.288,1356.84l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-826.849 -1208.535)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69498",
    "data-name": "Path 69498",
    d: "M969.194,1335.256l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.255.255,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-859.762 -1189.286)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69499",
    "data-name": "Path 69499",
    d: "M1006.1,1313.671l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-892.675 -1170.037)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69500",
    "data-name": "Path 69500",
    d: "M1043.008,1292.085l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-925.588 -1150.787)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69501",
    "data-name": "Path 69501",
    d: "M1079.914,1270.5l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-958.5 -1131.537)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69502",
    "data-name": "Path 69502",
    d: "M1116.821,1248.914l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.122.122,0,0,1,0-.211l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-991.414 -1112.287)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69503",
    "data-name": "Path 69503",
    d: "M1153.728,1227.328l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1024.327 -1093.037)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69504",
    "data-name": "Path 69504",
    d: "M1190.636,1205.744l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1057.241 -1073.789)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69505",
    "data-name": "Path 69505",
    d: "M1227.542,1184.159l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1090.153 -1054.539)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69506",
    "data-name": "Path 69506",
    d: "M1264.45,1162.573l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.122.122,0,0,1,0-.211l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1123.067 -1035.289)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69507",
    "data-name": "Path 69507",
    d: "M1301.356,1140.987l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1155.98 -1016.04)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69508",
    "data-name": "Path 69508",
    d: "M863.926,1447.113l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-765.884 -1289.039)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69509",
    "data-name": "Path 69509",
    d: "M900.833,1425.528l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.254.254,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-798.798 -1269.789)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69510",
    "data-name": "Path 69510",
    d: "M937.74,1403.941l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-831.711 -1250.539)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69511",
    "data-name": "Path 69511",
    d: "M974.645,1382.357l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-864.623 -1231.29)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69512",
    "data-name": "Path 69512",
    d: "M1011.552,1360.77l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-897.536 -1212.04)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69513",
    "data-name": "Path 69513",
    d: "M1048.459,1339.186l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-930.449 -1192.79)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69514",
    "data-name": "Path 69514",
    d: "M1085.367,1317.6l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-963.363 -1173.541)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69515",
    "data-name": "Path 69515",
    d: "M1122.273,1296.015l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.258.258,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-996.276 -1154.291)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69516",
    "data-name": "Path 69516",
    d: "M1159.18,1274.429l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1029.189 -1135.042)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69517",
    "data-name": "Path 69517",
    d: "M1196.087,1252.845l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.255.255,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-1062.102 -1115.793)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69518",
    "data-name": "Path 69518",
    d: "M1232.994,1231.259l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.211l2.484-1.438a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1095.016 -1096.542)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69519",
    "data-name": "Path 69519",
    d: "M1269.9,1209.674l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1127.928 -1077.294)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69520",
    "data-name": "Path 69520",
    d: "M1306.807,1188.089l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1160.84 -1058.044)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69521",
    "data-name": "Path 69521",
    d: "M1343.715,1166.5l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1193.755 -1038.794)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69522",
    "data-name": "Path 69522",
    d: "M909.322,1456.1l-5.489,3.206a.3.3,0,0,1-.3,0l-2.3-1.39a.122.122,0,0,1,0-.212l5.523-3.226a.255.255,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-803.659 -1297.056)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69523",
    "data-name": "Path 69523",
    d: "M943.19,1451.043l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-836.571 -1292.543)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69524",
    "data-name": "Path 69524",
    d: "M980.1,1429.458l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-869.485 -1273.295)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69525",
    "data-name": "Path 69525",
    d: "M1017,1407.872l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-902.398 -1254.044)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69526",
    "data-name": "Path 69526",
    d: "M1053.911,1386.286l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.122.122,0,0,1,0-.211l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-935.311 -1234.794)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69527",
    "data-name": "Path 69527",
    d: "M1090.818,1364.7l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-968.225 -1215.545)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69528",
    "data-name": "Path 69528",
    d: "M1127.725,1343.115l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1001.138 -1196.295)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69529",
    "data-name": "Path 69529",
    d: "M1164.632,1321.531l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.437a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1034.051 -1177.046)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69530",
    "data-name": "Path 69530",
    d: "M1201.538,1299.945l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.211l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1066.963 -1157.796)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69531",
    "data-name": "Path 69531",
    d: "M1238.445,1278.36l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-1099.877 -1138.547)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69532",
    "data-name": "Path 69532",
    d: "M1275.353,1256.775l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1132.79 -1119.297)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69533",
    "data-name": "Path 69533",
    d: "M1312.259,1235.189l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1165.703 -1100.047)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69534",
    "data-name": "Path 69534",
    d: "M1349.166,1213.6l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-1198.616 -1080.798)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69535",
    "data-name": "Path 69535",
    d: "M1360.542,1192.018l-5.549,3.248a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l5.583-3.267a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1205.999 -1061.548)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69536",
    "data-name": "Path 69536",
    d: "M948.643,1498.144l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-841.434 -1334.548)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69537",
    "data-name": "Path 69537",
    d: "M985.55,1476.557l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.254.254,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-874.347 -1315.297)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69538",
    "data-name": "Path 69538",
    d: "M1022.456,1454.973l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-907.26 -1296.048)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69539",
    "data-name": "Path 69539",
    d: "M1059.362,1433.387l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-940.173 -1276.798)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69540",
    "data-name": "Path 69540",
    d: "M1096.269,1411.8l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-973.086 -1257.549)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69541",
    "data-name": "Path 69541",
    d: "M1133.176,1390.217l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1005.999 -1238.299)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69542",
    "data-name": "Path 69542",
    d: "M1170.083,1368.632l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1038.912 -1219.05)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69543",
    "data-name": "Path 69543",
    d: "M1206.991,1347.045l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.254.254,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1071.826 -1199.799)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69544",
    "data-name": "Path 69544",
    d: "M1243.9,1325.461l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-1104.739 -1180.551)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69545",
    "data-name": "Path 69545",
    d: "M1280.8,1303.875l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1137.652 -1161.301)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69546",
    "data-name": "Path 69546",
    d: "M1317.711,1282.289l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1170.565 -1142.051)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69547",
    "data-name": "Path 69547",
    d: "M1354.617,1260.7l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.258.258,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1203.478 -1122.802)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69548",
    "data-name": "Path 69548",
    d: "M1391.524,1239.12l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1236.391 -1103.553)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69549",
    "data-name": "Path 69549",
    d: "M1428.432,1217.533l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1269.304 -1084.302)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69550",
    "data-name": "Path 69550",
    d: "M991,1523.659l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-879.209 -1357.302)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69551",
    "data-name": "Path 69551",
    d: "M1027.907,1502.074l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-912.121 -1338.053)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69552",
    "data-name": "Path 69552",
    d: "M1064.814,1480.488l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-945.034 -1318.803)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69553",
    "data-name": "Path 69553",
    d: "M1101.722,1458.9l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-977.948 -1299.552)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69554",
    "data-name": "Path 69554",
    d: "M1138.628,1437.317l-2.45,1.418a.294.294,0,0,1-.3,0l-2.3-1.39a.122.122,0,0,1,0-.211l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1010.861 -1280.303)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69555",
    "data-name": "Path 69555",
    d: "M1175.535,1415.731l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1043.774 -1261.053)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69556",
    "data-name": "Path 69556",
    d: "M1212.441,1394.147l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1076.686 -1241.804)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69557",
    "data-name": "Path 69557",
    d: "M1249.349,1372.562l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-1109.6 -1222.555)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69558",
    "data-name": "Path 69558",
    d: "M1286.255,1350.976l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1142.513 -1203.305)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69559",
    "data-name": "Path 69559",
    d: "M1323.162,1329.39l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.122.122,0,0,1,0-.211l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1175.426 -1184.055)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69560",
    "data-name": "Path 69560",
    d: "M1360.069,1307.805l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1208.34 -1164.806)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69561",
    "data-name": "Path 69561",
    d: "M1396.976,1286.219l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1241.253 -1145.556)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69562",
    "data-name": "Path 69562",
    d: "M1433.884,1264.635l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1274.167 -1126.307)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69563",
    "data-name": "Path 69563",
    d: "M1470.79,1243.05l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-1307.079 -1107.058)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69564",
    "data-name": "Path 69564",
    d: "M1033.359,1549.174l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.255.255,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-916.983 -1380.056)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69565",
    "data-name": "Path 69565",
    d: "M1070.267,1527.589l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-949.897 -1360.807)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69566",
    "data-name": "Path 69566",
    d: "M1107.172,1506l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-982.809 -1341.557)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69567",
    "data-name": "Path 69567",
    d: "M1144.079,1484.417l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.484-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1015.722 -1322.307)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69568",
    "data-name": "Path 69568",
    d: "M1195.6,1383.224l-17.059,10.032a.3.3,0,0,1-.3,0l-2.3-1.39a.122.122,0,0,1,0-.212l17.093-10.052a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1048.636 -1232.063)",
    fill: "#bca39d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69569",
    "data-name": "Path 69569",
    d: "M1217.894,1441.248l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1081.549 -1283.808)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69570",
    "data-name": "Path 69570",
    d: "M1254.8,1419.662l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1114.462 -1264.558)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69571",
    "data-name": "Path 69571",
    d: "M1291.707,1398.077l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.255.255,0,0,1,.26,0l2.3,1.393a.132.132,0,0,1,0,.228",
    transform: "translate(-1147.375 -1245.309)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69572",
    "data-name": "Path 69572",
    d: "M1328.614,1376.492l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.258.258,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1180.288 -1226.06)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69573",
    "data-name": "Path 69573",
    d: "M1365.521,1354.906l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.257.257,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1213.202 -1206.809)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69574",
    "data-name": "Path 69574",
    d: "M1402.428,1333.321l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1246.114 -1187.56)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69575",
    "data-name": "Path 69575",
    d: "M1439.334,1311.736l-2.451,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1279.027 -1168.311)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69576",
    "data-name": "Path 69576",
    d: "M1476.241,1290.15l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.123.123,0,0,1,0-.212l2.485-1.437a.255.255,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1311.94 -1149.061)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69577",
    "data-name": "Path 69577",
    d: "M1513.148,1268.565l-2.45,1.418a.3.3,0,0,1-.3,0l-2.3-1.39a.122.122,0,0,1,0-.211l2.485-1.438a.256.256,0,0,1,.26,0l2.3,1.394a.132.132,0,0,1,0,.228",
    transform: "translate(-1344.853 -1129.812)",
    fill: "#83869b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69578",
    "data-name": "Path 69578",
    d: "M1306.459,1462.318l-14.25,8.247a1.72,1.72,0,0,1-1.744-.023l-13.359-8.083a.713.713,0,0,1,.01-1.231l14.449-8.361a1.49,1.49,0,0,1,1.511.02l13.393,8.1a.769.769,0,0,1-.011,1.327",
    transform: "translate(-1138.599 -1295.474)",
    fill: "#755259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69579",
    "data-name": "Path 69579",
    d: "M866.155,243.247l4.67-2.658V225.166l-4.67,2.658Z",
    transform: "translate(-772.427 -200.8)",
    fill: "#b2a8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69580",
    "data-name": "Path 69580",
    d: "M952.565,141.722l4.67-2.658V117.433l-4.67,2.658Z",
    transform: "translate(-849.487 -104.725)",
    fill: "#b2a8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69581",
    "data-name": "Path 69581",
    d: "M1038.974,31.545l4.67-2.658V0l-4.67,2.658Z",
    transform: "translate(-926.545 0.003)",
    fill: "#b2a8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69582",
    "data-name": "Path 69582",
    d: "M1125.384,92.177l4.67-2.658V74.1l-4.67,2.658Z",
    transform: "translate(-1003.604 -66.078)",
    fill: "#b2a8c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67315",
    "data-name": "Group 67315",
    transform: "translate(60.845 71.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69583",
    "data-name": "Path 69583",
    d: "M562.277,730.857l48.663-28.2V658.733l-48.663,28.2Z",
    transform: "translate(-562.277 -658.733)",
    fill: "#fdf7ed",
    stroke: "#5b3439",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69588",
    "data-name": "Path 69588",
    d: "M638.946,955.381v24.8l36.945-21.093",
    transform: "translate(-630.65 -923.28)",
    fill: "none",
    stroke: "#40c6c2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5940",
    "data-name": "Line 5940",
    y1: 24.362,
    transform: "translate(12.841 29.942)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5941",
    "data-name": "Line 5941",
    y1: 24.362,
    transform: "translate(17.286 27.358)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5942",
    "data-name": "Line 5942",
    y1: 24.362,
    transform: "translate(21.73 24.773)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5943",
    "data-name": "Line 5943",
    y1: 24.362,
    transform: "translate(26.175 22.189)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5944",
    "data-name": "Line 5944",
    y1: 24.362,
    transform: "translate(30.619 19.604)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5945",
    "data-name": "Line 5945",
    y1: 24.362,
    transform: "translate(35.064 17.02)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5946",
    "data-name": "Line 5946",
    y1: 24.362,
    transform: "translate(39.508 14.436)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5947",
    "data-name": "Line 5947",
    y1: 24.362,
    transform: "translate(43.953 11.851)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5948",
    "data-name": "Line 5948",
    y1: 21.094,
    x2: 36.945,
    transform: "translate(8.297 32.101)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5949",
    "data-name": "Line 5949",
    y1: 21.094,
    x2: 36.945,
    transform: "translate(8.297 28.38)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5950",
    "data-name": "Line 5950",
    y1: 21.094,
    x2: 36.945,
    transform: "translate(8.297 24.658)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5951",
    "data-name": "Line 5951",
    y1: 21.094,
    x2: 36.945,
    transform: "translate(8.297 20.937)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5952",
    "data-name": "Line 5952",
    y1: 21.094,
    x2: 36.945,
    transform: "translate(8.297 17.216)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5953",
    "data-name": "Line 5953",
    y1: 21.094,
    x2: 36.945,
    transform: "translate(8.297 13.495)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69762",
    "data-name": "Path 69762",
    d: "M887.143,904l4.324-2.461V887.262l-4.324,2.461Z",
    transform: "translate(-851.989 -862.533)",
    fill: "#708dce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69763",
    "data-name": "Path 69763",
    d: "M807.149,883.015l4.324-2.461v-22.48l-4.324,2.461Z",
    transform: "translate(-780.651 -836.502)",
    fill: "#708dce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69764",
    "data-name": "Path 69764",
    d: "M720.982,952.476l4.324-2.461V929.99l-4.324,2.461Z",
    transform: "translate(-703.808 -900.635)",
    fill: "#708dce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69765",
    "data-name": "Path 69765",
    d: "M640.989,1046.463l4.323-2.461v-14.277l-4.323,2.461Z",
    transform: "translate(-632.471 -989.578)",
    fill: "#708dce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69589",
    "data-name": "Path 69589",
    d: "M638.946,818.451s4.88-.238,5.128.092,1.816-1.651,1.816-1.651l3.468.413,3.88-6.24,4.293-3.932,7.1-2.048.413-5.614,3.715-4.211v-4.376l6.408-8.529",
    transform: "translate(-569.805 -697.695)",
    fill: "none",
    stroke: "#e5495b",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69590",
    "data-name": "Path 69590",
    d: "M634.229,1194.846l6.12-3.557a1.21,1.21,0,0,0,.581-.917v-.114c0-.32-.261-.43-.581-.245l-6.12,3.557a1.211,1.211,0,0,0-.581.917v.114c0,.319.262.43.581.245",
    transform: "translate(-565.08 -1061.159)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69591",
    "data-name": "Path 69591",
    d: "M597.817,983.15l3.06-1.778a.6.6,0,0,0,.291-.458v-.057c0-.16-.131-.215-.291-.123l-3.06,1.778a.6.6,0,0,0-.291.458v.057c0,.16.131.215.291.123",
    transform: "translate(-532.868 -874.566)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69592",
    "data-name": "Path 69592",
    d: "M597.817,1018.168l3.06-1.778a.606.606,0,0,0,.291-.459v-.057c0-.16-.131-.215-.291-.123l-3.06,1.778a.6.6,0,0,0-.291.458v.057c0,.16.131.215.291.123",
    transform: "translate(-532.868 -905.796)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69593",
    "data-name": "Path 69593",
    d: "M597.817,1053.188l3.06-1.778a.605.605,0,0,0,.291-.458v-.057c0-.16-.131-.215-.291-.123l-3.06,1.778a.6.6,0,0,0-.291.458v.057c0,.16.131.215.291.123",
    transform: "translate(-532.868 -937.025)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69594",
    "data-name": "Path 69594",
    d: "M597.817,1088.206l3.06-1.778a.605.605,0,0,0,.291-.458v-.057c0-.16-.131-.215-.291-.123l-3.06,1.778a.6.6,0,0,0-.291.458v.057c0,.16.131.215.291.123",
    transform: "translate(-532.868 -968.255)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69595",
    "data-name": "Path 69595",
    d: "M597.817,1123.225l3.06-1.778a.605.605,0,0,0,.291-.458v-.057c0-.16-.131-.215-.291-.123l-3.06,1.778a.6.6,0,0,0-.291.458v.057c0,.16.131.215.291.123",
    transform: "translate(-532.868 -999.484)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69596",
    "data-name": "Path 69596",
    d: "M597.817,1158.244l3.06-1.778a.606.606,0,0,0,.291-.458v-.057c0-.16-.131-.215-.291-.123l-3.06,1.778a.6.6,0,0,0-.291.458v.057c0,.16.131.215.291.123",
    transform: "translate(-532.868 -1030.714)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69597",
    "data-name": "Path 69597",
    d: "M730.205,1138.734l6.121-3.556a1.211,1.211,0,0,0,.581-.917v-.114c0-.32-.262-.43-.581-.245l-6.121,3.557a1.21,1.21,0,0,0-.581.917v.114c0,.319.261.43.581.245",
    transform: "translate(-650.67 -1011.12)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69598",
    "data-name": "Path 69598",
    d: "M826.181,1082.622l6.121-3.557a1.21,1.21,0,0,0,.581-.917v-.114c0-.32-.261-.43-.581-.245l-6.121,3.557a1.21,1.21,0,0,0-.581.917v.114c0,.32.262.43.581.245",
    transform: "translate(-736.26 -961.08)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69599",
    "data-name": "Path 69599",
    d: "M922.157,1026.511l6.121-3.556a1.211,1.211,0,0,0,.581-.917v-.114c0-.32-.262-.43-.581-.245l-6.121,3.556a1.211,1.211,0,0,0-.581.917v.114c0,.319.262.43.581.245",
    transform: "translate(-821.851 -911.041)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69600",
    "data-name": "Path 69600",
    d: "M1958.121,1347.751l-10.464-6.2v40.858l10.464,6.2Z",
    transform: "translate(-1736.898 -1196.382)",
    fill: "#5b4169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69601",
    "data-name": "Path 69601",
    d: "M2044.355,1352.948l9.32-5.653v40.858l-9.32,5.653Z",
    transform: "translate(-1823.132 -1201.502)",
    fill: "#886d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69602",
    "data-name": "Path 69602",
    d: "M1958.121,1301.388l-10.464-6.274,9.32-5.635,10.464,6.274Z",
    transform: "translate(-1736.898 -1149.942)",
    fill: "#ae9bb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69603",
    "data-name": "Path 69603",
    d: "M1813.366,1536.693l-10.464-6.2v29.772l10.464,6.2Z",
    transform: "translate(-1607.808 -1364.878)",
    fill: "#5b4169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69604",
    "data-name": "Path 69604",
    d: "M1899.6,1541.887l9.32-5.653v29.773l-9.32,5.653Z",
    transform: "translate(-1694.041 -1369.996)",
    fill: "#886d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69605",
    "data-name": "Path 69605",
    d: "M1813.365,1490.327l-10.464-6.274,9.32-5.635,10.464,6.274Z",
    transform: "translate(-1607.807 -1318.436)",
    fill: "#ae9bb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69606",
    "data-name": "Path 69606",
    d: "M1668.608,1707.689l-10.464-6.2v20.628l10.464,6.2Z",
    transform: "translate(-1478.714 -1517.37)",
    fill: "#5b4169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69607",
    "data-name": "Path 69607",
    d: "M1754.844,1712.886l9.32-5.653v20.628l-9.32,5.653Z",
    transform: "translate(-1564.949 -1522.49)",
    fill: "#886d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69608",
    "data-name": "Path 69608",
    d: "M1668.608,1661.326l-10.464-6.274,9.32-5.635,10.464,6.274Z",
    transform: "translate(-1478.714 -1470.931)",
    fill: "#ae9bb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69609",
    "data-name": "Path 69609",
    d: "M1523.853,1866.144l-10.464-6.2v12.842l10.464,6.2Z",
    transform: "translate(-1349.623 -1658.678)",
    fill: "#5b4169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69610",
    "data-name": "Path 69610",
    d: "M1610.087,1871.339l9.32-5.653v12.841l-9.32,5.653Z",
    transform: "translate(-1435.857 -1663.797)",
    fill: "#886d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69611",
    "data-name": "Path 69611",
    d: "M1523.853,1819.78l-10.464-6.274,9.32-5.635,10.464,6.274Z",
    transform: "translate(-1349.623 -1612.238)",
    fill: "#ae9bb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69612",
    "data-name": "Path 69612",
    d: "M1061.922,531.258c.059-.1.117-.2.176-.3a29.648,29.648,0,0,1,9.771-10.13c4.433-2.657,8.358-2.841,10.778-.958l3.318,2.256-1.581-.034a9.621,9.621,0,0,1,.8,4.069,22.92,22.92,0,0,1-3.666,11.368c-.363.6-.747,1.194-1.154,1.773a30.933,30.933,0,0,1-5,5.6,24.885,24.885,0,0,1-2.593,1.989c-.2.132-.4.26-.6.388-.1.062-.2.125-.3.183s-.205.121-.3.18c-.2.114-.4.223-.6.333a13.311,13.311,0,0,1-5.409,1.681c-.235.015-.465.018-.688.015a7.239,7.239,0,0,1-1.49-.18,6.048,6.048,0,0,1-1.158-.388c-2.271-1.022-3.666-3.417-3.666-6.969a22.547,22.547,0,0,1,3.369-10.87",
    transform: "translate(-944.005 -462.498)",
    fill: "#657651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69613",
    "data-name": "Path 69613",
    d: "M1058.553,646.284c0,3.552.941,6.121,3.212,7.142.366.165,2.225,1.3,2.631,1.39.472.11-.049-1.006.471-.995.223,0,.454,0,.688-.015l.967-1.088-1.212-15.433-3.388-1.871a22.546,22.546,0,0,0-3.369,10.87",
    transform: "translate(-944.005 -566.655)",
    fill: "#a84c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69614",
    "data-name": "Path 69614",
    d: "M1088.234,562.179c0,3.552,1.4,5.948,3.666,6.969a6.074,6.074,0,0,0,1.158.388,7.259,7.259,0,0,0,1.49.179,12.629,12.629,0,0,0,6.1-1.7c.2-.11.4-.22.6-.333.1-.059.2-.121.3-.179s.2-.121.3-.183c.2-.128.4-.256.6-.388a24.916,24.916,0,0,0,2.593-1.989,30.926,30.926,0,0,0,5-5.6c.406-.579.791-1.172,1.154-1.772a22.922,22.922,0,0,0,3.666-11.368c0-7.354-5.962-9.738-13.312-5.332a29.65,29.65,0,0,0-9.771,10.13,22.8,22.8,0,0,0-3.545,11.17",
    transform: "translate(-970.474 -480.378)",
    fill: "#a9b974"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69615",
    "data-name": "Path 69615",
    d: "M1088.234,663.879c0,3.552,1.4,5.948,3.666,6.969a6.065,6.065,0,0,0,1.158.388,7.251,7.251,0,0,0,1.49.179l7-15.026-9.771-3.681a22.8,22.8,0,0,0-3.545,11.17",
    transform: "translate(-970.474 -582.078)",
    fill: "#e8726b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67241",
    "data-name": "Group 67241",
    transform: "translate(124.073 74.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67240",
    "data-name": "Group 67240",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25199",
    "data-name": "Rectangle 25199",
    width: 11.508,
    height: 15.753,
    transform: "translate(-1.034 0.071) rotate(-3.945)",
    fill: "#efc463"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67252",
    "data-name": "Group 67252",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67251",
    "data-name": "Group 67251",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69617",
    "data-name": "Path 69617",
    d: "M41.969,830,1.593,854.4A3.207,3.207,0,0,0,0,857.169v44.659c0,1.368,3.013,3.1,4.195,2.411L42.639,879.2a2.79,2.79,0,0,0,1.386-2.411l2.135-45.1c0-1.055-3.279-2.212-4.191-1.681",
    transform: "translate(0 -740.069)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69618",
    "data-name": "Path 69618",
    d: "M62.673,839.059,22.3,863.453a3.207,3.207,0,0,0-1.593,2.771v44.659a1.773,1.773,0,0,0,2.665,1.532l39.974-24.16a2.79,2.79,0,0,0,1.386-2.411v-45.6a1.368,1.368,0,0,0-2.056-1.182",
    transform: "translate(-18.464 -748.096)",
    fill: "#f8eadc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67244",
    "data-name": "Group 67244",
    transform: "translate(18.835 102.761)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67243",
    "data-name": "Group 67243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67242",
    "data-name": "Group 67242",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69619",
    "data-name": "Path 69619",
    d: "M196.564,949.625v1.218l-22.51,13.708v-1.218Z",
    transform: "translate(-174.054 -949.626)",
    fill: "#86626f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69620",
    "data-name": "Path 69620",
    d: "M196.564,982.091v1.218l-22.51,13.664v-1.218Z",
    transform: "translate(-174.054 -978.579)",
    fill: "#86626f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69621",
    "data-name": "Path 69621",
    d: "M196.564,1014.557v1.218l-22.51,13.664v-1.218Z",
    transform: "translate(-174.054 -1007.531)",
    fill: "#86626f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69622",
    "data-name": "Path 69622",
    d: "M196.564,1047.023v1.218l-22.51,13.664v-1.218Z",
    transform: "translate(-174.054 -1036.484)",
    fill: "#86626f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67247",
    "data-name": "Group 67247",
    transform: "translate(8.13 122.923)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67246",
    "data-name": "Group 67246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67245",
    "data-name": "Group 67245",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69623",
    "data-name": "Path 69623",
    d: "M130.914,1135.951v1.218l-30.476,18.359v-1.218Z",
    transform: "translate(-97.699 -1135.951)",
    fill: "#85616f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69624",
    "data-name": "Path 69624",
    d: "M108.348,1168.417v1.218l-33.214,19.892v-1.218Z",
    transform: "translate(-75.134 -1164.904)",
    fill: "#85616f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69625",
    "data-name": "Path 69625",
    d: "M108.348,1200.883v1.218l-33.214,19.892v-1.218Z",
    transform: "translate(-75.134 -1193.856)",
    fill: "#85616f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69626",
    "data-name": "Path 69626",
    d: "M108.348,1233.348v1.218l-33.214,19.892v-1.217Z",
    transform: "translate(-75.134 -1222.808)",
    fill: "#85616f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_69627",
    "data-name": "Path 69627",
    d: "M57.315,1089.543v11.713l10.744-6.228V1083.27Z",
    transform: "translate(-51.113 -966.047)",
    fill: "#e0782b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69628",
    "data-name": "Path 69628",
    d: "M231.84,1694.562c0-7.631-10.723-13.827-23.956-13.827s-23.956,6.2-23.956,13.827a7.68,7.68,0,0,1,0,2.5,7.677,7.677,0,0,1,0,2.5c0,7.631,10.735,13.828,23.956,13.828,12.961,0,23.5-5.937,23.932-13.345a3.154,3.154,0,0,0,.025-.482Zm-23.956,10.822c-8.859,0-16.286-3.556-18.242-8.326,1.955-4.771,9.383-8.326,18.242-8.326s16.289,3.556,18.242,8.326c-1.947,4.771-9.368,8.327-18.242,8.327",
    transform: "translate(-164.024 -1498.859)",
    fill: "#4f345b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69629",
    "data-name": "Path 69629",
    d: "M207.882,1667.146c-13.225,0-23.959,6.2-23.959,13.826s10.734,13.832,23.959,13.832c12.96,0,23.494-5.94,23.93-13.347a3.216,3.216,0,0,0,.024-.485c0-7.627-10.725-13.826-23.954-13.826m18.729,14.208c-.01.166-.025.338-.049.5-.768,5.563-8.831,9.942-18.68,9.942-9.824,0-17.892-4.369-18.69-9.922a6.11,6.11,0,0,1-.064-.9c0-5.969,8.405-10.817,18.753-10.817s18.748,4.849,18.748,10.817a2.5,2.5,0,0,1-.02.382",
    transform: "translate(-164.02 -1486.742)",
    fill: "#f8e9e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69630",
    "data-name": "Path 69630",
    d: "M571.745,1886.143c.012-.088.028-.176.045-.264.012-.06.022-.12.035-.18s.027-.112.041-.168c.02-.078.04-.157.063-.236.013-.045.027-.091.042-.136q.042-.132.088-.264c.013-.036.026-.073.039-.109.045-.122.094-.243.146-.363l.017-.038c.048-.109.1-.217.152-.323l.049-.1c.052-.1.106-.2.161-.3l.032-.057q.1-.171.208-.338l.064-.095q.08-.12.164-.235c.03-.042.061-.083.092-.125.048-.065.1-.128.149-.19s.085-.1.128-.156.083-.095.125-.142q.108-.12.22-.235c.036-.037.073-.073.11-.109a5.954,5.954,0,0,1,.465-.409l.085-.064a4.99,4.99,0,0,1,.515-.348,4.029,4.029,0,0,1,.415-.207c.044-.019.086-.035.129-.052q.118-.046.233-.081c.049-.015.1-.029.147-.041s.091-.021.135-.029.118-.02.175-.027l.1-.01a2.043,2.043,0,0,1,.211,0h.049a1.87,1.87,0,0,1,.244.031l.058.013a1.706,1.706,0,0,1,.182.052l.056.02a1.6,1.6,0,0,1,.216.1l-17.241-10.02-.018-.01a1.529,1.529,0,0,0-.166-.081l-.033-.012-.055-.02c-.029-.01-.057-.022-.086-.031s-.064-.015-.1-.022l-.058-.013-.031-.007a1.775,1.775,0,0,0-.2-.023h-.062c-.052,0-.1,0-.157,0-.018,0-.037,0-.055.005l-.1.01c-.031,0-.061,0-.092.009s-.055.012-.082.018c-.045.009-.09.018-.136.029-.024.006-.048.009-.073.016s-.05.018-.074.025q-.115.034-.233.081c-.028.01-.054.016-.082.028s-.032.017-.047.024a3.965,3.965,0,0,0-.416.207,5.007,5.007,0,0,0-.515.348l-.085.064a5.957,5.957,0,0,0-.465.409c-.013.012-.027.022-.039.034s-.047.051-.07.075c-.075.076-.148.154-.22.235-.023.025-.047.049-.07.075s-.036.045-.055.067c-.044.051-.086.1-.129.156-.028.034-.057.067-.084.1s-.043.059-.064.087l-.092.125c-.021.029-.043.056-.063.085-.034.049-.067.1-.1.149l-.065.1-.026.04q-.088.138-.171.279l-.01.019c-.011.019-.021.038-.032.057-.038.067-.076.134-.112.2-.017.032-.032.064-.049.1l-.049.1c-.015.029-.03.058-.044.087-.038.078-.073.156-.107.235l-.019.04-.005.011q-.064.148-.121.3c-.007.019-.013.037-.02.055-.014.036-.026.073-.039.109s-.037.1-.053.148-.023.078-.036.116-.028.091-.042.136c-.008.028-.018.056-.026.083-.014.051-.024.1-.037.152s-.029.113-.041.169c0,.02-.01.039-.014.059-.009.041-.013.081-.021.122-.017.088-.033.176-.045.264,0,.024-.009.049-.013.073s0,.045,0,.067a4.9,4.9,0,0,0-.038.58,2.312,2.312,0,0,0,.963,2.118l17.241,10.02a2.312,2.312,0,0,1-.963-2.118,4.938,4.938,0,0,1,.038-.58c.005-.047.01-.093.017-.14",
    transform: "translate(-494.451 -1668.26)",
    fill: "#685275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69631",
    "data-name": "Path 69631",
    d: "M717.069,1963.727c1.824-1.053,3.307-.209,3.313,1.887a7.25,7.25,0,0,1-3.291,5.7c-1.824,1.053-3.307.209-3.313-1.887a7.252,7.252,0,0,1,3.291-5.7",
    transform: "translate(-636.539 -1750.824)",
    fill: "#4a4d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69632",
    "data-name": "Path 69632",
    d: "M710.99,1965.841c.018-.129.042-.259.067-.389.017-.089.032-.177.052-.266s.04-.166.061-.249c.029-.116.059-.232.092-.348.02-.067.041-.134.062-.2q.061-.2.131-.39c.019-.054.038-.107.058-.161.068-.179.139-.359.216-.536l.026-.056c.071-.161.146-.32.225-.478.024-.049.048-.1.073-.145q.114-.222.238-.44c.016-.028.031-.057.047-.085.1-.169.2-.336.307-.5.031-.048.063-.094.094-.14q.118-.177.242-.348c.045-.062.09-.123.135-.184.072-.1.146-.189.22-.281.063-.078.125-.155.189-.231s.123-.14.185-.21q.16-.178.325-.347c.054-.055.108-.109.162-.162a8.944,8.944,0,0,1,.686-.6c.042-.033.084-.063.126-.094a7.346,7.346,0,0,1,.761-.514,5.924,5.924,0,0,1,.614-.305c.064-.028.128-.052.191-.077.116-.045.231-.085.344-.119.073-.022.145-.043.217-.06s.134-.031.2-.043c.087-.017.173-.03.258-.04.049-.006.1-.011.146-.015a3.114,3.114,0,0,1,.312-.006c.024,0,.049,0,.073,0a2.728,2.728,0,0,1,.36.045c.029.006.057.013.086.02a2.391,2.391,0,0,1,.269.077c.027.01.055.018.082.029a2.353,2.353,0,0,1,.32.152l-25.475-14.8-.027-.015a2.3,2.3,0,0,0-.245-.12c-.016-.007-.032-.011-.048-.017s-.055-.02-.082-.029c-.042-.015-.083-.032-.127-.045s-.094-.022-.142-.033c-.028-.006-.057-.014-.086-.02l-.046-.011a2.738,2.738,0,0,0-.295-.034h-.019c-.024,0-.048,0-.072,0-.076,0-.153-.005-.232,0-.026,0-.054.006-.081.008-.048,0-.1.009-.146.015s-.09.007-.136.014-.082.019-.122.026c-.067.012-.133.026-.2.043-.036.009-.071.013-.107.023s-.073.027-.109.038c-.113.033-.228.073-.344.118-.041.016-.08.025-.121.042-.023.01-.047.025-.07.035a5.85,5.85,0,0,0-.614.305,7.334,7.334,0,0,0-.761.514c-.042.032-.084.062-.126.095a8.813,8.813,0,0,0-.686.6c-.019.018-.039.032-.058.051-.036.035-.069.075-.1.111q-.166.168-.325.347c-.034.038-.07.072-.1.111s-.054.067-.082.1c-.065.076-.128.154-.19.232-.041.051-.084.1-.124.151s-.063.086-.1.129c-.046.061-.091.123-.136.185-.031.042-.063.083-.093.126-.051.072-.1.147-.148.221-.032.048-.064.094-.1.142l-.039.059q-.13.2-.252.412l-.015.028c-.016.028-.031.057-.047.085-.056.1-.113.2-.166.3-.025.047-.048.095-.072.142s-.049.1-.073.145-.044.085-.065.128c-.055.115-.108.231-.159.347-.009.02-.019.04-.027.06l-.008.017q-.094.217-.179.437c-.01.027-.019.054-.029.081-.02.054-.039.108-.058.162-.026.073-.054.145-.078.218-.019.057-.034.115-.052.172s-.042.134-.062.2c-.012.041-.026.082-.037.124-.021.075-.036.15-.055.224s-.043.166-.061.249c-.006.029-.015.058-.021.086-.013.06-.02.12-.031.18-.025.13-.048.26-.067.389-.005.036-.014.072-.019.108s0,.066-.006.1a7.193,7.193,0,0,0-.056.856,3.416,3.416,0,0,0,1.423,3.13l25.475,14.8a3.416,3.416,0,0,1-1.423-3.13,7.178,7.178,0,0,1,.056-.856c.008-.069.015-.137.025-.207",
    transform: "translate(-611.262 -1732.753)",
    fill: "#a58094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69633",
    "data-name": "Path 69633",
    d: "M925.712,2080.474c2.7-1.557,4.886-.308,4.895,2.789a10.712,10.712,0,0,1-4.863,8.422c-2.7,1.557-4.886.309-4.894-2.789a10.712,10.712,0,0,1,4.863-8.422",
    transform: "translate(-821.203 -1854.745)",
    fill: "#685275"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67250",
    "data-name": "Group 67250",
    transform: "translate(25.172 185.209)",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67249",
    "data-name": "Group 67249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67248",
    "data-name": "Group 67248",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69634",
    "data-name": "Path 69634",
    d: "M269.987,1721.448c-.768,5.563-8.831,9.942-18.68,9.942-9.824,0-17.892-4.369-18.69-9.922.8-5.553,8.865-9.923,18.69-9.923s17.873,4.36,18.68,9.9",
    transform: "translate(-232.618 -1711.545)",
    fill: "#d0a6c5"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_69635",
    "data-name": "Path 69635",
    d: "M218.07,250.919l-57.153,34.37c-1.634.942-4.31-1.306-4.31-3.192V258.229a5.611,5.611,0,0,1,2.809-4.861L217.6,219.837c1.566-.9,4.733.242,4.733,2.05l-1.211,23.745a6.1,6.1,0,0,1-3.055,5.287",
    transform: "translate(-139.66 -195.767)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69636",
    "data-name": "Path 69636",
    d: "M233.627,258.936l-57.788,33.3a2.451,2.451,0,0,1-3.675-2.124V266.246a5.611,5.611,0,0,1,2.809-4.861l58.186-33.531a2.35,2.35,0,0,1,3.523,2.036v23.759a6.1,6.1,0,0,1-3.055,5.287",
    transform: "translate(-153.534 -202.914)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69637",
    "data-name": "Path 69637",
    d: "M569.287,333.45a16.97,16.97,0,0,1-2.709,8.405q-.4.667-.855,1.311a21.8,21.8,0,0,1-5.613,5.607c-.147.1-.294.192-.443.285-.074.046-.149.092-.223.136s-.149.09-.223.131c-.149.085-.3.167-.444.247a8.256,8.256,0,0,1-5.61,1.123,4.571,4.571,0,0,1-.857-.287c-1.679-.757-2.709-2.528-2.709-5.155,0-5.435,4.407-12.485,9.843-15.745s9.843-1.495,9.843,3.94",
    transform: "translate(-490.129 -292.394)",
    fill: "#fffaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69638",
    "data-name": "Path 69638",
    d: "M596.894,388.549c0,.064,0,.127,0,.192q-.34.563-.722,1.107a18.418,18.418,0,0,1-4.741,4.737c-.124.082-.249.162-.375.241-.062.039-.126.078-.188.115s-.126.076-.188.111c-.126.072-.25.141-.375.208a6.975,6.975,0,0,1-4.74.948,3.838,3.838,0,0,1-.724-.242c0-.061,0-.124,0-.186,0-2.815,1.928-6.335,4.537-8.564-.806-.017-1.345-.584-1.345-1.6a6.058,6.058,0,0,1,2.839-4.541c1.566-.939,2.839-.43,2.839,1.136a5.477,5.477,0,0,1-1.345,3.218c2.608-.9,4.537.308,4.537,3.123",
    transform: "translate(-521.548 -339.415)",
    fill: "#4a79a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69639",
    "data-name": "Path 69639",
    d: "M488.051,458.356l1.109-.641a1.854,1.854,0,0,0,.89-1.4v-.174c0-.49-.4-.659-.89-.376l-1.109.641a1.854,1.854,0,0,0-.89,1.4v.174c0,.49.4.659.89.376",
    transform: "translate(-434.444 -406.319)",
    fill: "#ffebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69640",
    "data-name": "Path 69640",
    d: "M209.925,496.08l26.935-15.564a1.854,1.854,0,0,0,.89-1.4v-.174c0-.49-.4-.659-.89-.376l-26.935,15.564a1.854,1.854,0,0,0-.89,1.4v.174c0,.489.4.659.89.376",
    transform: "translate(-186.415 -426.653)",
    fill: "#ffebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69641",
    "data-name": "Path 69641",
    d: "M488.051,501.013l1.109-.641a1.854,1.854,0,0,0,.89-1.4v-.174c0-.49-.4-.659-.89-.376l-1.109.641a1.854,1.854,0,0,0-.89,1.4v.174c0,.489.4.659.89.376",
    transform: "translate(-434.444 -444.361)",
    fill: "#ffebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69642",
    "data-name": "Path 69642",
    d: "M209.925,538.739l26.935-15.564a1.854,1.854,0,0,0,.89-1.4V521.6c0-.489-.4-.659-.89-.376l-26.935,15.564a1.854,1.854,0,0,0-.89,1.4v.174c0,.49.4.659.89.376",
    transform: "translate(-186.415 -464.695)",
    fill: "#ffebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69643",
    "data-name": "Path 69643",
    d: "M488.051,543.672l1.109-.641a1.854,1.854,0,0,0,.89-1.4v-.175c0-.489-.4-.659-.89-.376l-1.109.641a1.854,1.854,0,0,0-.89,1.4v.174c0,.49.4.659.89.376",
    transform: "translate(-434.444 -482.403)",
    fill: "#ffebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69644",
    "data-name": "Path 69644",
    d: "M209.925,581.4l26.935-15.564a1.854,1.854,0,0,0,.89-1.4v-.174c0-.49-.4-.659-.89-.376l-26.935,15.564a1.854,1.854,0,0,0-.89,1.4v.175c0,.49.4.659.89.376",
    transform: "translate(-186.415 -502.737)",
    fill: "#ffebe0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67254",
    "data-name": "Group 67254",
    transform: "translate(180.168 21.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67253",
    "data-name": "Group 67253",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25204",
    "data-name": "Rectangle 25204",
    width: 19.927,
    height: 34.416,
    transform: "translate(0 0)",
    fill: "#c35716"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67256",
    "data-name": "Group 67256",
    transform: "translate(185.149 23.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67255",
    "data-name": "Group 67255",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25205",
    "data-name": "Rectangle 25205",
    width: 16.254,
    height: 34.416,
    transform: "translate(0 0)",
    fill: "#e68238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67261",
    "data-name": "Group 67261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67260",
    "data-name": "Group 67260",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69647",
    "data-name": "Path 69647",
    d: "M1764.358,196.124l4.98,2.709-3.629,5.525-4.98-2.709Z",
    transform: "translate(-1570.198 -174.901)",
    fill: "#a34615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69648",
    "data-name": "Path 69648",
    d: "M1664.96,470.81l4.98,2.709.231,4.692-4.98-2.709Z",
    transform: "translate(-1484.792 -419.862)",
    fill: "#a34615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69649",
    "data-name": "Path 69649",
    d: "M1556.492,171.2c-2.435-1.4-13.317,4.025-17.285,6.243-3.879,2.168-7.134,4.573-9.564,8.581l-4.981-2.709A38.007,38.007,0,0,1,1538,169.956c5.378-3.007,10.194-3.339,13.509-1.467Z",
    transform: "translate(-1359.676 -149.223)",
    fill: "#527e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69650",
    "data-name": "Path 69650",
    d: "M1488.1,359.631a21.534,21.534,0,0,0-.914,6.834c0,6.613,3.175,7.472,9.5,4.958l4.98,2.709-4.018,4.506c-9.032,4.034-16.928-2.09-16.928-11.394a26.437,26.437,0,0,1,2.4-10.321Z",
    transform: "translate(-1320.485 -318.299)",
    fill: "#464265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69651",
    "data-name": "Path 69651",
    d: "M1593.983,198.735c-2.435-1.4-5.987-1.16-9.955,1.059a27.906,27.906,0,0,0-9.788,9.793l-3.553-1.242a38.006,38.006,0,0,1,13.34-13.357c5.378-3.006,10.194-3.339,13.509-1.467Z",
    transform: "translate(-1400.721 -171.546)",
    fill: "#69b19d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69652",
    "data-name": "Path 69652",
    d: "M1532.75,383.413a18.328,18.328,0,0,0-1.2,6.175c0,6.613,4.835,9.379,11.16,6.865l.09,4.819c-9.032,4.034-16.056.305-16.056-9a26.437,26.437,0,0,1,2.4-10.321Z",
    transform: "translate(-1361.53 -340.621)",
    fill: "#6b70a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67259",
    "data-name": "Group 67259",
    transform: "translate(116.534 85.11)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67258",
    "data-name": "Group 67258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67257",
    "data-name": "Group 67257",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69653",
    "data-name": "Path 69653",
    d: "M1127.567,786.51v1.4l-21.536,12.574v-1.4Z",
    transform: "translate(-1102.88 -786.51)",
    fill: "#ffebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69654",
    "data-name": "Path 69654",
    d: "M1101.594,823.879v1.4l-24.688,14.338v-1.4Z",
    transform: "translate(-1076.906 -819.835)",
    fill: "#ffebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69655",
    "data-name": "Path 69655",
    d: "M1101.594,861.248v1.4l-24.688,14.338v-1.4Z",
    transform: "translate(-1076.906 -853.161)",
    fill: "#ffebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69656",
    "data-name": "Path 69656",
    d: "M1101.594,898.618v1.4l-24.688,14.338v-1.4Z",
    transform: "translate(-1076.906 -886.486)",
    fill: "#ffebe0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_69657",
    "data-name": "Path 69657",
    d: "M1181.6,614.488l73.6-42.766a3.8,3.8,0,0,1,5.713,3.288v64.373a6.977,6.977,0,0,1-3.471,6.032l-72.6,42.188a4.768,4.768,0,0,1-7.163-4.122V621.313a7.893,7.893,0,0,1,3.928-6.825",
    transform: "translate(-1050.232 -509.391)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69658",
    "data-name": "Path 69658",
    d: "M1205.385,624.6l73.6-42.766a3.8,3.8,0,0,1,5.713,3.288V649.5a6.977,6.977,0,0,1-3.471,6.032l-72.6,42.188a4.768,4.768,0,0,1-7.163-4.122V631.428a7.893,7.893,0,0,1,3.928-6.825",
    transform: "translate(-1071.446 -518.411)",
    fill: "#fffaf2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_69659",
    "data-name": "Path 69659",
    transform: "translate(-1071.446 -518.411)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1205.385,624.6l73.6-42.766a3.8,3.8,0,0,1,5.713,3.288V649.5a6.977,6.977,0,0,1-3.471,6.032l-72.6,42.188a4.768,4.768,0,0,1-7.163-4.122V631.428A7.893,7.893,0,0,1,1205.385,624.6Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1280.887084960938 583.3165893554688 C 1280.5751953125 583.3165893554688 1280.272583007812 583.4005737304688 1279.987426757812 583.5662841796875 L 1206.389526367188 626.3321533203125 C 1204.580688476562 627.3832397460938 1203.45703125 629.3357543945312 1203.45703125 631.427734375 L 1203.45703125 693.596435546875 C 1203.45703125 695.3103637695312 1204.897583007812 696.3712158203125 1206.232177734375 696.3712158203125 C 1206.7138671875 696.3712158203125 1207.179077148438 696.2427368164062 1207.615234375 695.9893798828125 L 1280.219482421875 653.801025390625 C 1281.746826171875 652.9135131835938 1282.695678710938 651.2645874023438 1282.695678710938 649.497802734375 L 1282.695678710938 585.1248779296875 C 1282.695678710938 584.0079345703125 1281.7568359375 583.3165893554688 1280.887084960938 583.3165893554688 M 1280.887084960938 581.3165893554688 C 1282.873046875 581.3165893554688 1284.695678710938 582.9042358398438 1284.695678710938 585.1248779296875 L 1284.695678710938 649.497802734375 C 1284.695678710938 651.9835205078125 1283.373413085938 654.281494140625 1281.224365234375 655.5302734375 L 1208.619995117188 697.7186279296875 C 1205.441284179688 699.565673828125 1201.45703125 697.2724609375 1201.45703125 693.596435546875 L 1201.45703125 631.427734375 C 1201.45703125 628.6156005859375 1202.953125 626.015869140625 1205.384765625 624.6029052734375 L 1278.982543945312 581.8370361328125 C 1279.597534179688 581.4796752929688 1280.250854492188 581.3165893554688 1280.887084960938 581.3165893554688 Z",
    stroke: "none",
    fill: "#d0b0ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67314",
    "data-name": "Group 67314",
    transform: "translate(146.344 88.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69660",
    "data-name": "Path 69660",
    d: "M1352.389,1034.471v40.614l52.647-30.058",
    transform: "translate(-1352.389 -1010.893)",
    fill: "none",
    stroke: "#40c6c2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5954",
    "data-name": "Line 5954",
    y1: 34.716,
    transform: "translate(6.476 25.779)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5955",
    "data-name": "Line 5955",
    y1: 34.716,
    transform: "translate(12.809 22.096)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5956",
    "data-name": "Line 5956",
    y1: 34.716,
    transform: "translate(19.143 18.413)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5957",
    "data-name": "Line 5957",
    y1: 34.715,
    transform: "translate(25.476 14.731)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5958",
    "data-name": "Line 5958",
    y1: 34.716,
    transform: "translate(31.81 11.048)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5959",
    "data-name": "Line 5959",
    y1: 34.716,
    transform: "translate(38.143 7.365)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5960",
    "data-name": "Line 5960",
    y1: 34.715,
    transform: "translate(44.477 3.683)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5961",
    "data-name": "Line 5961",
    y1: 34.715,
    transform: "translate(50.81)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5962",
    "data-name": "Line 5962",
    y1: 30.058,
    x2: 52.647,
    transform: "translate(0 28.855)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5963",
    "data-name": "Line 5963",
    y1: 30.058,
    x2: 52.647,
    transform: "translate(0 23.553)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5964",
    "data-name": "Line 5964",
    y1: 30.058,
    x2: 52.647,
    transform: "translate(0 18.25)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5965",
    "data-name": "Line 5965",
    y1: 30.058,
    x2: 52.647,
    transform: "translate(0 12.947)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5966",
    "data-name": "Line 5966",
    y1: 30.058,
    x2: 52.647,
    transform: "translate(0 7.644)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5967",
    "data-name": "Line 5967",
    y1: 30.058,
    x2: 52.647,
    transform: "translate(0 2.341)",
    fill: "none",
    stroke: "#8d9ab2",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69661",
    "data-name": "Path 69661",
    d: "M1363.4,977.307l6.94-16,6.941-1.53,1.294-4.353,2.706-5.177,4-1.412,3.412-3.53.824-5.765,4-4.824,4.706,2.941,3.03-3.174,3.933-2.286,1.86-5.129,7.193-1.475",
    transform: "translate(-1215.866 -825.431)",
    fill: "none",
    stroke: "#4bb497",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69662",
    "data-name": "Path 69662",
    d: "M1359.03,888.254s6.236-.471,6.589,0,2.588-2.353,2.588-2.353l4.941.588,5.53-8.892,6.118-5.6,10.118-2.918.588-8,5.294-6V848.84l9.131-12.154",
    transform: "translate(-1211.967 -746.146)",
    fill: "none",
    stroke: "#e68238",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69663",
    "data-name": "Path 69663",
    d: "M1376.084,919.688l10.034-5.831a1.984,1.984,0,0,0,.953-1.5v-.187c0-.524-.428-.7-.953-.4l-10.034,5.831a1.984,1.984,0,0,0-.953,1.5v.187c0,.524.429.705.953.4",
    transform: "translate(-1226.326 -812.971)",
    fill: "#aac3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69664",
    "data-name": "Path 69664",
    d: "M1345.667,1424.481l8.721-5.068a1.724,1.724,0,0,0,.828-1.306v-.162c0-.455-.373-.613-.828-.35l-8.721,5.068a1.725,1.725,0,0,0-.828,1.307v.162c0,.456.373.613.828.35",
    transform: "translate(-1199.311 -1264.081)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69665",
    "data-name": "Path 69665",
    d: "M1293.78,1122.817l4.361-2.534a.863.863,0,0,0,.414-.653v-.081c0-.228-.187-.306-.414-.175l-4.361,2.534a.863.863,0,0,0-.414.653v.081c0,.228.187.306.414.175",
    transform: "translate(-1153.409 -998.187)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69666",
    "data-name": "Path 69666",
    d: "M1293.78,1172.719l4.361-2.534a.863.863,0,0,0,.414-.653v-.081c0-.228-.187-.306-.414-.175l-4.361,2.534a.864.864,0,0,0-.414.654v.081c0,.228.187.306.414.175",
    transform: "translate(-1153.409 -1042.689)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69667",
    "data-name": "Path 69667",
    d: "M1293.78,1222.621l4.361-2.534a.863.863,0,0,0,.414-.653v-.081c0-.228-.187-.306-.414-.175l-4.361,2.534a.863.863,0,0,0-.414.653v.081c0,.228.187.306.414.175",
    transform: "translate(-1153.409 -1087.191)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69668",
    "data-name": "Path 69668",
    d: "M1293.78,1272.522l4.361-2.534a.863.863,0,0,0,.414-.653v-.081c0-.228-.187-.306-.414-.175l-4.361,2.534a.864.864,0,0,0-.414.653v.082c0,.227.187.306.414.175",
    transform: "translate(-1153.409 -1131.692)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69669",
    "data-name": "Path 69669",
    d: "M1293.78,1322.424l4.361-2.534a.863.863,0,0,0,.414-.654v-.081c0-.228-.187-.306-.414-.175l-4.361,2.534a.863.863,0,0,0-.414.653v.081c0,.228.187.306.414.175",
    transform: "translate(-1153.409 -1176.194)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69670",
    "data-name": "Path 69670",
    d: "M1293.78,1372.324l4.361-2.534a.862.862,0,0,0,.414-.653v-.081c0-.228-.187-.306-.414-.175l-4.361,2.534a.862.862,0,0,0-.414.653v.081c0,.228.187.306.414.175",
    transform: "translate(-1153.409 -1220.696)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69671",
    "data-name": "Path 69671",
    d: "M1482.432,1344.523l8.722-5.068a1.725,1.725,0,0,0,.828-1.306v-.162c0-.455-.373-.613-.828-.35l-8.722,5.068a1.725,1.725,0,0,0-.828,1.306v.162c0,.456.373.613.828.35",
    transform: "translate(-1321.277 -1192.774)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69672",
    "data-name": "Path 69672",
    d: "M1619.2,1264.565l8.721-5.068a1.725,1.725,0,0,0,.828-1.307v-.162c0-.455-.373-.613-.828-.349l-8.721,5.068a1.724,1.724,0,0,0-.828,1.307v.162c0,.455.373.613.828.349",
    transform: "translate(-1443.242 -1121.469)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69673",
    "data-name": "Path 69673",
    d: "M1755.961,1184.606l8.722-5.068a1.725,1.725,0,0,0,.828-1.307v-.162c0-.455-.372-.613-.828-.349l-8.722,5.068a1.725,1.725,0,0,0-.828,1.306v.162c0,.455.373.613.828.349",
    transform: "translate(-1565.208 -1050.163)",
    fill: "#ad8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69674",
    "data-name": "Path 69674",
    d: "M1376.084,924.831l18.991-10.974a1.984,1.984,0,0,0,.953-1.5v-.187c0-.524-.429-.7-.953-.4l-18.991,10.974a1.984,1.984,0,0,0-.953,1.5v.187c0,.524.429.7.953.4",
    transform: "translate(-1226.326 -812.97)",
    fill: "#aac3a8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpIs);
export default __webpack_public_path__ + "static/media/KPIs.f60ecd846127f0de3e044eec57e78efb.svg";
export { ForwardRef as ReactComponent };